import { Injectable } from '@angular/core';
import { SortColumn } from 'src/app/models/sortColumn.model';
import { AccessGroupsVM } from 'src/app/views/management/access-groups/access-groups.component';

@Injectable({
  providedIn: 'root',
})
export class AccessGroupsSortingService {
  public sortAccessGroups(data: AccessGroupsVM[], sortColumn: SortColumn): AccessGroupsVM[] {
    // Handle both ITableColumn (propertyKey) and PrimeTableColumn (prop)
    const column = sortColumn?.column as { propertyKey?: string; prop?: string };
    const propertyKey = column?.propertyKey || column?.prop;

    if (!propertyKey || !data || data.length === 0) {
      return data;
    }

    const isDesc = sortColumn.isDesc;

    return [...data].sort((a, b) => {
      const valueA = this._getValue(a, propertyKey);
      const valueB = this._getValue(b, propertyKey);

      let comparison = 0;

      if (valueA === null || valueA === undefined) {
        comparison = 1;
      } else if (valueB === null || valueB === undefined) {
        comparison = -1;
      } else if (valueA instanceof Date && valueB instanceof Date) {
        comparison = valueA.getTime() - valueB.getTime();
      } else if (this._isDateLike(valueA) && this._isDateLike(valueB)) {
        comparison = new Date(valueA as string | number).getTime() - new Date(valueB as string | number).getTime();
      } else if (typeof valueA === 'number' && typeof valueB === 'number') {
        comparison = valueA - valueB;
      } else if (typeof valueA === 'string' && typeof valueB === 'string') {
        comparison = valueA.toLowerCase().localeCompare(valueB.toLowerCase());
      } else if (Array.isArray(valueA) && Array.isArray(valueB)) {
        const strA = valueA[0]?.toString().toLowerCase() ?? '';
        const strB = valueB[0]?.toString().toLowerCase() ?? '';
        comparison = strA.localeCompare(strB);
      }

      return isDesc ? -comparison : comparison;
    });
  }

  private _getValue(item: AccessGroupsVM, propertyKey: string): unknown {
    return item[propertyKey as keyof AccessGroupsVM];
  }

  private _isDateLike(value: unknown): boolean {
    if (value instanceof Date) return true;
    if (typeof value === 'string' || typeof value === 'number') {
      const date = new Date(value);
      return !isNaN(date.getTime());
    }
    return false;
  }
}
